<template>
  <div>
    <page-header></page-header>
    <div class="content">
      <div v-if="viewMode === 'projects'">
        <div class="instructor-heading">
          <h1>Your Sessions:</h1>
          <button @click="openSignatureModal" class="inspdfButton">Signature</button>
        </div>
        <div v-if="projects.length === 0 && !processing" class="no-projects-message">
          <p style="color: rgb(216, 4, 4)">You have no assigned sessions.</p>
        </div>
        <div v-else-if="processing" class="no-projects-message">
          <p style="color: #777777; margin-bottom: 0px;">Loading ...</p>
        </div>
        <div v-else class="project-container">
          <div v-for="project in projects" :key="project.project_id" class="project-box"
            :class="{ locked: project.locked }" @click="selectProject(project)">
            <div class="product-card">
              <div class="section id-section">
                <div class="id-row">
                  <p class="logbook-id" style="font-size: 16px; padding-left: 0px;">
                    <b>ID: {{ project.project_id }}</b>
                    <span v-if="project.locked" class="lock-icon">🔒 Locked</span>
                  </p>
                </div>
                <h2 class="logbook-name" style="font-size: 16px;">{{ project.name }}</h2>
              </div>
              <div class="inst-section">
                <p>
                  <b style="font-size: 14px;">Instructors:</b>

                  <span v-if="!project.instructors || project.instructors.length === 0" style="margin-left: 8px;">
                    None
                  </span>

                  <span v-else style="margin-left: 8px;">
                    <span
                      v-for="(ins) in project.instructors.slice(0, 2)"
                      :key="ins.user_id"
                      class="instructor-chip"
                      :title="`${ins.last_name}, ${ins.first_name}`"
                    >
                      {{ ins.last_name }}, {{ ins.first_name }}  
                    </span>

                    <span
                      v-if="project.instructors.length > 2"
                      class="instructor-more"
                      :title="project.instructors
                        .slice(2)
                        .map(i => `${i.last_name}, ${i.first_name}`)
                        .join('\n')"
                    >
                      +{{ project.instructors.length - 2 }} more
                    </span>
                  </span>
                </p>
                <p style="margin-top: 10px; font-size: 14px;"><b>Location:</b> {{ project.location }}</p>
              </div>
              <div class="date-section">
                <p style="font-size: 14px;"><b>Start Date:</b> {{ project.start_date }}</p>
                <p style="margin-top: 10px; font-size: 14px;"><b>End Date:</b> {{ project.end_date }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="viewMode === 'logbooks'">
        <div class="instructor-heading">
          <div>
            <h1>Logbooks for Session: {{ selectedProject.project_id }}</h1>
          </div>
          <div>
            <button @click="multiEnable" class="multiEnableButton">Multi Assign</button>
            <button @click="multiSignOff" class="multiSignOffButton">Multi Sign Off</button>
            <button @click="clearLogbooks" class="back-button">Back to Sessions</button>
          </div>
        </div>
        <div v-if="logbooks.length === 0 && !processing" class="no-projects-message">
          <p style="color: rgb(216, 4, 4)">There are no logbooks assigned to this session.</p>
        </div>
        <div v-else-if="processing" class="no-projects-message">
          <p style="color: #777777; margin-bottom: 0px;">Loading ...</p>
        </div>
        <div v-else class="product-container">
          <div v-for="logbook in logbooks" :key="logbook.logbook_id" class="logbook-box"
            :class="{ locked: logbook.locked }"
            @click="openLogbook(logbook.logbook_id, logbook.project_id, logbook.product_id, logbook.trainee_id)">
            <div class="product-card">
              <div class="section id-section">
                <div class="id-row">
                  <p class="logbook-id" style="font-size: 16px; padding-left: 0px;">
                    <b>{{ logbook.traineeName }}</b>
                    <span v-if="logbook.locked" class="lock-icon">🔒 Locked</span>
                  </p>
                </div>
                <h2 class="logbook-name">{{ logbook.name }}</h2>
                <!-- <span class="product-name">{{ logbook.productName }}</span> -->
              </div>

              <div class="section tasks-section">
                <!-- <p><span class="label">MT/AT:</span><span class="value">{{ logbook.totalTasks }}</span></p> -->
                <p><span class="label">Assigned:</span><span class="value">{{ logbook.enabledTasks }}</span></p>
                <p><span class="label">Incomplete:</span><span class="value">{{ logbook.incompleteTasks }}</span></p>
              </div>
              <div class="section tasks-section">
                <p>
                  <span class="label">Not Signed Off:</span>
                  <span class="value">{{ logbook.notSignedOffTasks }}</span>
                </p>

                <div class="evaluation-status-container">
                  <div
                    v-if="getEvaluationStatusText(logbook.logbook_id)"
                    :class="getEvaluationStatusClass(logbook.logbook_id)"
                    class="evaluation-status-box"
                  >
                    {{ getEvaluationStatusText(logbook.logbook_id) }}
                  </div>
                </div>
              </div>
              <div class="section tasks-section">
                <p><span class="label">Main Tasks:</span><span class="value">{{ logbook.mainTasks }}</span></p>
                <p><span class="label">Complete:</span><span class="value">{{ logbook.mainCompleted }}</span></p>
                <p><span class="label">Percent:</span><span class="value" :class="{ 'percent-green': logbook.completedPercent >= logbook.passRate, 'percent-orange': logbook.completedPercent < logbook.passRate }">{{ logbook.completedPercent }}%</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <signature-modal v-if="showSignatureModal" role="instructor" @close="closeSignatureModal"></signature-modal>
  </div>
</template>

<script>
import PageHeader from '../Examiner/Header.vue';
import axios from 'axios';
import SignatureModal from '@/components/Examiner/SignatureModal.vue';

export default {
  name: 'InstructorHome',
  components: { 
    PageHeader, 
    SignatureModal 
  },
  data() {
    return {
      processing: false,
      selectedProject: {},
      viewMode: 'projects',
      projects: [],
      logbooks: [],
      currentTime: '',
      loggedInUser: '',
      showModal: false,
      logbook: {
        totalTasks: 0,
        incompleteTasks: 0,
        enabledTasks: 0,
        mainTasks: 0,
        mainCompleted: 0,
        completedPercent: 0,
      },
      showSignatureModal: false,
      evaluationMap: {},
    };
  },
  async mounted() {
    try {
      this.processing = true;
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const savedProject = localStorage.getItem('selectedProject');

      if (savedProject) {
        this.selectedProject = JSON.parse(savedProject);
        this.selectProject(this.selectedProject);
      } else {
        this.viewMode = 'projects'; // Default to projects view
      }

      // Single call returns the instructor's sessions with their instructors
      const result = await axios.get('/api/instructor/home-summary', { headers });
      this.projects = (result.data || []).sort((a, b) => b.project_id - a.project_id);

      const loggedInUser = localStorage.getItem('username');
      this.loggedInUser = loggedInUser;
      this.processing = false;

    } catch (error) {
      this.processing = false;
      if (error.response && error.response.status === 401) {
        this.$router.push({ name: 'LoginPage' });
      } else {
        console.error(error);
      }
    }
  },
  methods: {
    clearLogbooks() {
      this.viewMode = 'projects';
      this.logbooks = [];
      localStorage.removeItem('selectedProject'); // Remove saved project
    },
    groupEvaluationsByLogbook(evaluations) {
      return (evaluations || []).reduce((acc, evaluation) => {
        const logbookId = evaluation.logbook_id;
        if (!acc[logbookId]) {
          acc[logbookId] = [];
        }
        acc[logbookId].push(evaluation);
        return acc;
      }, {});
    },
    getCurrentEvaluationForLogbook(logbookId) {
      const evaluations = this.evaluationMap[logbookId] || [];
      if (!evaluations.length) return null;

      const continuous = evaluations.find(e => e.evaluation_type === 'continuous') || null;
      const remedial = evaluations.find(e => e.evaluation_type === 'remedial') || null;

      // remedial takes priority if it exists
      return remedial || continuous || null;
    },
    getEvaluationStatusText(logbookId) {
      const evaluation = this.getCurrentEvaluationForLogbook(logbookId);
      if (!evaluation) return '';

      if (evaluation.is_submitted === 0) return 'Evaluation in progress';
      if (evaluation.is_submitted === 1) return 'Awaiting signature';

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'Evaluation passed';
        }
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'Evaluation remedial';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'Evaluation passed';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'Evaluation failed';
        }
        return 'Signed';
      }

      return '';
    },
    getEvaluationStatusClass(logbookId) {
      const evaluation = this.getCurrentEvaluationForLogbook(logbookId);
      if (!evaluation) return '';

      if (evaluation.is_submitted === 0) return 'pending-box';
      if (evaluation.is_submitted === 1) return 'pending-box';

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'success-box';
        }
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'expired-box';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'success-box';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'expired-box';
        }
        return 'success-box';
      }

      return 'pending-box';
    },
    async selectProject(project) {
      this.selectedProject = project;
      localStorage.setItem('selectedProject', JSON.stringify(project));
      this.viewMode = 'logbooks';
      this.processing = true;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      try {
        // Single call returns each trainee's logbook with trainee, product, KPIs and evaluations
        const result = await axios.get(`/api/instructor/projects/${project.project_id}/logbooks-summary`, { headers });

        this.logbooks = result.data || [];
        this.evaluationMap = this.groupEvaluationsByLogbook(this.logbooks.flatMap(logbook => logbook.evaluations || []));
        this.logbooks.sort((a, b) => (a.traineeName || '').localeCompare(b.traineeName || ''));
        this.processing = false;
      } catch (error) {
        console.error('Error fetching logbooks:', error);
        this.processing = false;
      }
    },
    openLogbook(logbookId, projectId, productId, traineeId) {
      const token = localStorage.getItem('token');
      localStorage.setItem('logbook_id', logbookId);
      localStorage.setItem('project_id', projectId);
      localStorage.setItem('productId', productId);
      localStorage.setItem('trainee_id', traineeId);
      const logbook = this.logbooks.find(l => l.logbook_id === logbookId);
      if (logbook?.product) {
        localStorage.setItem('currentProduct', JSON.stringify(logbook.product));
      }
      if (!token) {
        this.$router.push({ name: 'examinerLogin' });
        return;
      }
      // Trainee and instructors already come from the summaries, no need to refetch
      if (logbook) {
        localStorage.setItem('traineeName', `${logbook.traineeFirstName} ${logbook.traineeLastName}`);
      }
      localStorage.setItem('instructorIds', JSON.stringify((this.selectedProject.instructors || []).map(i => i.user_id)));

      this.$router.push({ name: 'InstructorLogbook', params: { logbookId, productId, traineeId } });
    },
    async multiSignOff() {
      this.$router.push({
        name: 'MultiSignOff',
        params: { projectId: this.selectedProject.project_id }
      });
    },
    async multiEnable() {
      this.$router.push({
        name: 'MultiEnable',
        params: { projectId: this.selectedProject.project_id }
      });
    },
    openSignatureModal(event) {
      try {
        this.showSignatureModal = true;
      } catch (error) {
        console.error('Error opening signature modal:', error);
        // If `error` is actually an Event object, this will help surface more info.
        console.error('Event details:', event);
      }
    },
    async closeSignatureModal() {
      this.showSignatureModal = false;
    },
  },
};
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  /* Add space from the top */
}

.product-name {
  font-size: 14px;
  color: grey;
  border: none;
}

.trainee-email,
.instructor-email {
  font-weight: bold;
  color: grey;
  margin: 0;
  margin-top: 10px;
}

h2 {
  font-size: 1.3rem;
  margin-bottom: 25px;
}

h1 {
  font-size: 2rem;
  margin-top: 0;
  margin-bottom: 20px;
  padding-top: 0px;
  top: 7px;
}

.product-box {
  margin: 10px;
  width: 100%;
  height: 80px;
}

.viewbutton-container {
  display: flex;
  justify-content: flex-start;
  /* Align the button to the left within the container */
  width: 100%;
  /* Make the container take up the full width */
  margin-top: 0;
}

.product-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  margin-bottom: 20px;
  width: 90%;
}

.product-card {
  background-color: #f3f8ff;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow:
    3px 3px 3px rgba(0, 0, 0, 0.2),
    -3px -3px 3px rgba(0, 0, 0, 0.2),
    0 0 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  cursor: pointer;
  width: 90vw;
  height: auto;
  margin-bottom: 2px;
  gap: 0px;
}

/* Each section has a fixed width */
.section {
  flex-shrink: 0;
}

.section p {
  display: flex;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
}

.label {
  font-weight: bold;
}

.value {
  text-align: right;
  font-weight: bold;
}

.id-section {
  flex: 1;
  height: 100%;
  padding: 5px 0;
  padding-right: 20px;
}

.logbook-id {
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 10px;
}

.tasks-section {
  width: 220px;
}

.trainee-section {
  width: 270px;
}

.inst-section {
  width: 420px;
  padding-right: 10px;
}

.date-section {
  width: 220px;
}

/* Optional: make the text cleaner */
.product-card h2,
.product-card p,
.product-card span {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  background-color: #f3f8ff;
  border: 1px solid #f3f8ff;
}

.logbook-name {
  font-size: 16px;
  font-weight: normal;
  color: #2c3e50;
  margin: 0;
  padding: 0px;
  padding-bottom: 10px;
  align-self: left;
  /* centers the name horizontally */
  text-align: left;
  width: 100%;
}

/* Hover effect */
.product-card:hover {
  transform: scale(1.02);
  box-shadow:
    3px 3px 3px rgba(0, 0, 0, 0.2),
    -3px -3px 3px rgba(0, 0, 0, 0.2),
    0 0 3px rgba(0, 0, 0, 0.2);
}

.product-card h2 {
  margin-left: 0;
}

.product-card:hover {
  transform: scale(1.03);
}

.view-button {
  /* Rounded corners for the button */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* Shadow effect */
  background-color: #0a407a;
  /* Button background color */
  color: #ffffff;
  /* Button text color */
  padding: 10px 15px;
  width: 20%;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: auto;
  margin-bottom: 1px;
  /* Add spacing between the text and the button */
}

.task-summary {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
}

.task-summary p {
  margin-bottom: 3px;
  /* Adjust as needed to reduce the gap */
}

.project-container {
  margin-top: 0;
  width: 95%;
  margin-bottom: 20px;
}

p {
  margin-top: 0px;
  margin-bottom: 0px;
}

.back-button {
  width: 150px;
  border-radius: 5px;
  background-color: #c1e0bf;
  font-size: 14px;
  border: 2px solid black;
  padding: 3px;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.multiSignOffButton {
  margin-top: 0px;
  font-size: 16px;
  border-radius: 5px;
  width: 180px;
  height: 40px;
  background-color: #003f86;
  color: white;
  margin-right: 20px;
  border: 1px solid #01162e;
}

.multiSignOffButton:hover {
  background-color: #012c5e;
}

.multiEnableButton {
  margin-top: 0px;
  font-size: 16px;
  border-radius: 5px;
  width: 180px;
  height: 40px;
  background-color: #003f86;
  color: white;
  margin-right: 20px;
  border: 1px solid #01162e;
}

.multiEnableButton:hover {
  background-color: #012c5e;
}

h1 {
  font-size: 1.75rem;
  margin-top: 0;
  margin-bottom: 20px;
  padding-top: 10px;
  top: 7px;
  text-align: left;
}

.disabled-checkbox {
  cursor: not-allowed;
  opacity: 0.6;
}

.inspdfButton {
  border-radius: 5px;
  width: 150px;
  height: 40px;
  background-color: #a52c0d;
  color: white;
  padding: 5px;
  font-size: 16px;
  border: 1px solid #491204;
  margin-right: 20px;
}

.inspdfButton:hover {
  background-color: #791e08;
}

.instructor-heading {
  display: flex;
  justify-content: space-between;
  min-width: 85vw;
}

.id-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lock-icon {
  color: #d80404;
  font-size: 14px;
  font-weight: bold;
  padding-left: 20px;
}

.lock-icon:hover {
  color: rgb(198, 0, 0) !important;
  font-size: 14px;
  font-weight: bold;
}

.project-box.locked,
.logbook-box.locked {
  opacity: 0.7;
}

.multiSignOffButton:disabled,
.multiEnableButton:disabled {
  background-color: #ccc;
  border: 1px solid #acacac;
  cursor: not-allowed;
  opacity: 0.8;
}

.no-projects-message {
  width: 95%;
  padding: 30px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  text-align: center;
}

.percent-green {
  color: green;
  font-weight: bold;
}

.percent-green:hover {
  color: rgb(4, 107, 4) !important;
  font-weight: bold;
}

.percent-orange {
  color: rgb(205, 109, 0);
  font-weight: bold;
}

.percent-orange:hover {
  color: rgb(171, 92, 1) !important;
  font-weight: bold;
}

.evaluation-status-container {
  display: flex;
  justify-content: center;
  padding-right: 20px;
  margin-top: 5px;
}

.evaluation-status-box {
  width: auto;
  padding: 4px 8px;
  font-size: 14px;
  text-align: center;
  margin-left: 30px;
  margin-right: 10px;
  border-radius: 5px;
  margin-bottom: 0;
  justify-content: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.expired-box {
  background-color: rgb(250, 190, 190);
  color: rgb(194, 0, 0);
  border: 1px solid rgb(201, 141, 141);
}

.success-box {
  background-color: #b0e6bd;
  color: rgb(0, 119, 16);
  border: 1px solid #82c492;
}

.pending-box {
  background: rgb(255, 216, 144);
  color: rgb(160, 85, 0);
  border: 1px solid rgb(231, 189, 111);
}

.instructor-chip {
  display: inline-block;
  background: #eef2f7 !important;
  color: #333;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 13px;
  margin-right: 5px;
  margin-top: 4px;
}

.instructor-more {
  display: inline-block;
  background: #dbeafe !important;
  color: #1d4ed8;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 13px;
  margin-top: 4px;
  cursor: help;
}

.instructor-chip:hover {
  display: inline-block;
  background: #dbeafe;
  color: #1d4ed8;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 13px;
  margin-top: 4px;
  cursor: help;
}

.instructor-more:hover {
  display: inline-block;
  background: #dbeafe;
  color: #1d4ed8;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 13px;
  margin-top: 4px;
  cursor: help;
}

.inspdfButton {
  border-radius: 5px;
  width: 150px;
  height: 40px;
  background-color: #a52c0d;
  color: white;
  padding: 5px;
  font-size: 16px;
  border: 1px solid #491204;
  float: right;
}

.inspdfButton:hover {
  background-color: #791e08;
}
</style>